import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import PropertyUpdateModalSF from '../../../components/superUser/settings/PropertyUpdateModalSF'
import './PropertyListPage.css'

const PropertyListPageUI = ({ context, propertyList, errorList,
  // modes
  updateMode, selectedProperty,
  // event handlers
  onRefreshClick, onUpdateClick, onCancelClick, onUpdate
}) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_props' topnav='settings' backLink='/su/settings'
    headerText='Properties' centered={!propertyList && !errorList} page='properties'
  >
    {
      !propertyList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      propertyList && propertyList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Properties' />
        <PropertyListUI
          context={context}
          propertyList={propertyList}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          onUpdate={onUpdate}
        />
      </div>
    }

    <PropertyUpdateModalSF
      context={context}
      errorList={errorList}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
      selectedProperty={selectedProperty}
      onUpdate={onUpdate}
    />
  </SuperUserSettingsPageUI>

const PropertyListUI = ({ context, propertyList, onRefreshClick, onUpdateClick }) =>
  <div className='su_props'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI ontext={context} onRefreshClick={onRefreshClick} />
      }
      right={<span />}
    />
    <LRTableBodyUI>
      {
        propertyList.map((property, i) =>
          <LRTableRowUI key={i}
            context={context}
            rowId={property.propertyCode}
            left={<RowLeftUI context={context} property={property} />}
            right={<RowRightUI property={property} onUpdateClick={onUpdateClick} />}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const RowLeftUI = ({ context, property }) =>
  <div className='g_flex_v left'>
    <span>{property.propertyName}</span>
    {
      property.hint &&
      <span className='g_muted'>{property.hint}</span>
    }
  </div>

const RowRightUI = ({ property, onUpdateClick }) =>
  <div className='g_flex_h right'>
    {
      property.propertyType !== 'boolean_' &&
      <span className='wrap'>{property.propertyValue || property.defaultValue}</span>
    }
    {
      property.propertyType === 'boolean_' &&
      <span>{property.propertyValue != null ? (property.propertyValue === '1' ? 'Yes' : 'No') :
         (property.defaultValue === '1' ? 'Yes' : 'No')}</span>
    }
    <span className='icon icon-pencil g_link_2 g_m_left_50'
      data-property={property.propertyName} onClick={onUpdateClick} />
  </div>

const ActionLeftUI = ({ context, onRefreshClick }) =>
  <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />

export default PropertyListPageUI
